<div class="flex-align-center">
  <div class="card-breadcrumb">

    <span class="breadcrumb" pTooltip="{{homeTooltip | translate}}" tooltipPosition="bottom">
      <i class="fa fa-home" [routerLink]="homeRoute" ></i>
    </span>

    <span *ngFor="let breadcrumb of arrayBreadcrumbs;let i=index;" class="breadcrumb breadcrumb-menu">
      <i class="fa fa-chevron-right chevron"></i>
      <span [ngClass]="{'breadCrumbLast': i == (arrayBreadcrumbs.length-1) }" (click)="onClick(breadcrumb)">{{breadcrumb.description}}</span>
    </span>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kv-breadcrumb/kv-breadcrumb/kv-breadcrumb.component.html